import React, { createContext, ReactNode, useContext } from 'react';
import { useHttpClientCore } from '@/shared';
import { ApiAuditLogRepository } from '../repositories/ApiAuditLogRepository';
import { ApiAuditTrailRepository } from '../repositories/ApiAuditTrailRepository';
import { FetchAuditLogsUseCase } from '../../application/use-cases/FetchAuditLogsUseCase';
import { FetchAuditTrailUseCase } from '../../application/use-cases/FetchAuditTrailUseCase';

interface AuditLogDIContextType {
  fetchAuditLogsUseCase: FetchAuditLogsUseCase;
  fetchAuditTrailUseCase: FetchAuditTrailUseCase;
}

const AuditLogDIContext = createContext<AuditLogDIContextType | undefined>(undefined);

export const AuditLogDIProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const httpClient = useHttpClientCore();
  const auditLogRepository = new ApiAuditLogRepository(httpClient);
  const auditTrailRepository = new ApiAuditTrailRepository(httpClient);
  const fetchAuditLogsUseCase = new FetchAuditLogsUseCase(auditLogRepository);
  const fetchAuditTrailUseCase = new FetchAuditTrailUseCase(auditTrailRepository);

  const value = {
    fetchAuditLogsUseCase,
    fetchAuditTrailUseCase,
  };

  return <AuditLogDIContext.Provider value={value}>{children}</AuditLogDIContext.Provider>;
};

export const useAuditLogDIContext = (): AuditLogDIContextType => {
  const context = useContext(AuditLogDIContext);
  if (!context) {
    throw new Error('useAuditLogDIContext must be used within AuditLogDIProvider');
  }
  return context;
};
